module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays-img-2.0054a835.jpeg";